<template>
    <div>
        <div class="relative border border-gray-300 bg-gray-warm-50 rounded-md px-6 py-5">
            <h2 class="text-gray-400 text-lg font-semibold pb-3">
                Envelope Title
            </h2>

            <input-text
                v-if="editable"
                v-model="title_proxy"
                name="envelope-title"
                input_class="text-lg font-semibold w-full"
                :autofocus="creating"
            />

            <div v-else
                class="text-lg font-semibold w-full"
            >
                {{ title_proxy }}
            </div>

            <div class="absolute top-0 right-0">
                <toast-message :message="toast" />
            </div>
        </div>
    </div>
</template>

<script>
import ToastMessage from '../../../components/toast-message.vue';

export default {
    components: {
        ToastMessage,
    },

    props: {
        value: {},
        creating: { default: false },
        toast: {},
        envelope: {},
    },

    data() {
        return {
            title_proxy: this.value,
        }
    },

    computed: {
        editable() {
            return ! this.envelope?.sent_at;
        },
    },

    watch: {
        title_proxy: {
            handler(value) {
                this.$emit('input', value);
            },
            immediate: false,
        },
    },
}
</script>
